function useAccountInitials(currentAccount) {
  if (!currentAccount.name) return '?'
  return currentAccount?.name.split(' ').reduce((acc, curr) => acc += curr.charAt(0), '')
}

export default useAccountInitials
